export enum CalibrationMode {
  Neither = 'none',
  Homeplate = 'homePlate',
  LandingArea = 'landingArea',
}

export const CalibrationTypeDict: {
  [key in CalibrationMode]: string;
} = {
  none: 'Neither',
  homePlate: 'Home plate',
  landingArea: 'Landing area',
};
